import React, { useState } from 'react';
import { Box, Typography, Button, Grid, Card, CardContent, CardActionArea } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ApplicationsViewListing from './ApplicationsViewListing';
import { RemoveRedEye } from '@mui/icons-material';
import ApplicationList from './ApplicationsList';

const ApplicationMenu = () => {
    const navigate = useNavigate();
    const [titleViewName, setTitleViewName] = useState("");
    const [applicationViewType, setApplicationViewType] = useState("UNDER");
    const [currentView, setCurrentView] = useState("LISTING");

    const handleViewListing = () => {
        setCurrentView("LISTING");
    };
    
    const handleViewGraduateApplications = () => {
        setTitleViewName("Graduate Students Applications");
        setApplicationViewType("GRADUATE")
        setCurrentView("GRADUATEAPPLICATIONS");
    };
    
    const handleViewUndergraduateApplications = () => {
        setTitleViewName("Undergraduate Students Applications");
        setApplicationViewType("UNDER")
        setCurrentView("UNDERGRADUATEAPPLICATIONS");
    };
    
    const handleViewShortCourseApplications = () => {
        setTitleViewName("Short Course Students Applications");
        setApplicationViewType("SHORT")
        setCurrentView("SHORTCOURSEAPPLICATIONS");
    };
    
    const handleViewInServiceApplications = () => {
        setTitleViewName("In Service Students Applications");
        setApplicationViewType("INSERVICE")
        setCurrentView("INSERVICEAPPLICATIONS");
    };
    
    const handleOther = () => {
        // Handle other applications
    };
	const handleApplicationsPreviewListing= () => {
        setCurrentView("APPLICATIONSPREVIEW");
    };

    const menuItems = [
        {
            title: 'Graduate Applications',
            description: 'View all submitted applications',
            action: handleViewGraduateApplications,
        },
        {
            title: 'Undergraduate Applications',
            description: 'Manage applications, statuses and more',
            action: handleViewUndergraduateApplications,
        },
        {
            title: 'Short Course Applications',
            description: 'Manage applications, statuses and more',
            action: handleViewShortCourseApplications,
        },
        {
            title: 'In Service Applications',
            description: 'Manage applications, statuses and more ',
            action: handleViewInServiceApplications
        },
        {
            title: 'Other Applications',
            description: 'Manage applications, statuses and more',
            action: handleOther,
        },
		{
            title: 'Other Applications',
            description: 'Manage applications, statuses and more',
            action: handleOther,
        },
    ];

    return (
        <>
            {currentView === "LISTING" && (
                <Box sx={{ p: 3 }}>
					<Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                        <Typography variant="h4" gutterBottom align="center" sx={{ mb: 4 }}>
							<b>Select Application Type</b>
						</Typography>

                        <Button 
                            variant="contained" 
                            startIcon={<RemoveRedEye />}
                            onClick={handleApplicationsPreviewListing}
                        >
                            Preview Applications
                        </Button>
                    </Box>
					
                    <Grid container spacing={3} alignItems="stretch">
                        {menuItems.map((item, index) => (
                            <Grid item xs={12} sm={6} md={4} key={index} sx={{ display: 'flex' }}>
                                <Card 
                                    sx={{ 
                                        width: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        backgroundColor: '#e8f5e9', // Light green background
                                        borderBottom: '4px solid #2e7d32', // Dark green bottom border
                                        transition: 'transform 0.3s, box-shadow 0.3s',
                                        '&:hover': {
                                            transform: 'translateY(-5px)',
                                            boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                                        }
                                    }}
                                >
                                    <CardActionArea 
                                        onClick={item.action}
                                        sx={{
                                            height: '100%',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'space-between',
                                            alignItems: 'flex-start',
                                            p: 2
                                        }}
                                    >
                                        <CardContent sx={{ width: '100%' }}>
                                            <Typography variant="h6" component="div" sx={{ mb: 1, color: '#2e7d32' }}>
                                                {item.title}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {item.description}
                                            </Typography>
                                        </CardContent>
                                    </CardActionArea>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            )}

            {currentView === "GRADUATEAPPLICATIONS" && (
                <ApplicationsViewListing 
                    applicationViewType={applicationViewType} 
                    onCancel={handleViewListing} 
                    titleViewName={titleViewName}
                />
            )}
            
            {currentView === "UNDERGRADUATEAPPLICATIONS" && (
                <ApplicationsViewListing 
                    applicationViewType={applicationViewType} 
                    onCancel={handleViewListing} 
                    titleViewName={titleViewName}
                />
            )}
            
            {currentView === "SHORTCOURSEAPPLICATIONS" && (
                <ApplicationsViewListing 
                    applicationViewType={applicationViewType} 
                    onCancel={handleViewListing} 
                    titleViewName={titleViewName}
                />
            )}
            
            {currentView === "INSERVICEAPPLICATIONS" && (
                <ApplicationsViewListing 
                    applicationViewType={applicationViewType} 
                    onCancel={handleViewListing} 
                    titleViewName={titleViewName}
                />
            )}
			{currentView === "APPLICATIONSPREVIEW" && (
				<>
				<ApplicationList/>
				</>
			)}
        </>
    );
};

export default ApplicationMenu;